
  var _styles = {
  "count-down-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "count-down-time": {
    "color": "rgb(255,75,16)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "marginRight": "0.05333rem"
  },
  "count-down-suffix": {
    "color": "rgb(153,153,153)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  }
};



  module.exports = _styles;
  